import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";
export const FETCH_MEMBERSHIP_ATTRITION_RATE = "saga/FETCH_MEMBERSHIP_ATTRITION_RATE";
export const FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS = "saga/FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS";
export const FETCH_MEMBERSHIP_ATTRITION_RATE_FAILURE = "saga/FETCH_MEMBERSHIP_ATTRITION_RATE_FAILURE";
export const FETCH_MEMBERSHIP_ACTIVITY_REVENUE = "saga/FETCH_MEMBERSHIP_ACTIVITY_REVENUE";
export const FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS = "saga/FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS";
export const FETCH_MEMBERSHIP_ACTIVITY_REVENUE_FAILURE = "saga/FETCH_MEMBERSHIP_ACTIVITY_REVENUE_FAILURE";
export const FETCH_MEMBERSHIP_ACTIVITY_TOTALS = "saga/FETCH_MEMBERSHIP_ACTIVITY_TOTALS";
export const FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS = "saga/FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS";
export const FETCH_MEMBERSHIP_ACTIVITY_TOTALS_FAILURE = "saga/FETCH_MEMBERSHIP_ACTIVITY_TOTALS_FAILURE";
export const FETCH_MEMBERSHIP_ACTIVITY_VALUES = "saga/FETCH_MEMBERSHIP_ACTIVITY_VALUES";
export const FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS = "saga/FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS";
export const FETCH_MEMBERSHIP_ACTIVITY_VALUES_FAILURE = "saga/FETCH_MEMBERSHIP_ACTIVITY_VALUES_FAILURE";
export const FETCH_SALES_ACTIVITY_REVENUE = "saga/FETCH_SALES_ACTIVITY_REVENUE";
export const FETCH_SALES_ACTIVITY_REVENUE_SUCCESS = "saga/FETCH_SALES_ACTIVITY_REVENUE_SUCCESS";
export const FETCH_SALES_ACTIVITY_REVENUE_FAILURE = "saga/FETCH_SALES_ACTIVITY_REVENUE_FAILURE";
export const FETCH_INTROS_BOOKED = "saga/FETCH_INTROS_BOOKED";
export const FETCH_INTROS_BOOKED_SUCCESS = "saga/FETCH_INTROS_BOOKED_SUCCESS";
export const FETCH_INTROS_BOOKED_FAILURE = "saga/FETCH_INTROS_BOOKED_FAILURE";
export const FETCH_BAR_CHART = "saga/FETCH_BAR_CHART";
export const FETCH_BAR_CHART_SUCCESS = "saga/FETCH_BAR_CHART_SUCCESS";
export const FETCH_BAR_CHART_FAILURE = "saga/FETCH_BAR_CHART_FAILURE";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const SET_FILTERS_DIRTY = "sagas/SET_FILTERS_DIRTY";
export const SET_SELECTED_RANGE_OPTION = "sagas/SET_SELECTED_RANGE_OPTION";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateDates: createAction(UPDATE_DATES)
};
export default function* watchStudio() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

  // Default to MTD
  const endDate = data.payload.calendarEndDate;

  const startDate = moment(endDate)
    .startOf("month")
    .format("YYYY-MM-DD");

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });

  yield put({
    type: SET_SELECTED_RANGE_OPTION,
    payload: true
  });

  const sagaArguments = yield select(state => [
    state.studioInfo.currentUser.organization_id,
    state.studioInfo.currentUser.current_object_id,
    state.studioInfo.currentUser.current_location_id,
    state.studioInfo.currentUser.current_region_id
  ]);

  const allSagas = [
    getMembershipAttritionRate(...sagaArguments, startDate, endDate),
    getMembershipActivityTotals(...sagaArguments, startDate, endDate),
    getMembershipActivityValues(...sagaArguments, startDate, endDate),
    getSalesActivityRevenue(...sagaArguments, startDate, endDate),
    getIntrosBooked(...sagaArguments, startDate, endDate),
    getSalesActivityBarChartValues(...sagaArguments, startDate, endDate),
    getMembershipActivityRevenue(...sagaArguments, startDate, endDate)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData() {
  yield put({ type: SET_LOADING, payload: true });

  const sagaArguments = yield select(state => [
    state.studioInfo.currentUser.organization_id,
    state.studioInfo.currentUser.current_object_id,
    state.studioInfo.currentUser.current_location_id,
    state.studioInfo.currentUser.current_region_id,
    state.studioInfo.selectedRequestDates.startDate,
    state.studioInfo.selectedRequestDates.endDate
  ]);

  const allSagas = [
    getMembershipAttritionRate(...sagaArguments),
    getMembershipActivityTotals(...sagaArguments),
    getMembershipActivityValues(...sagaArguments),
    getSalesActivityRevenue(...sagaArguments),
    getIntrosBooked(...sagaArguments),
    getSalesActivityBarChartValues(...sagaArguments),
    getMembershipActivityRevenue(...sagaArguments)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getMembershipAttritionRate(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/corporate/memberships/activity/attrition_rate", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString(),
      start_date: startDate.toString(),
      end_date: endDate.toString()
    });

    yield put({ type: FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ATTRITION_RATE_FAILURE, error });
  }
}

export function* getMembershipActivityRevenue(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/corporate/memberships/activity/revenues", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString(),
      start_date: startDate.toString(),
      end_date: endDate.toString()
    });

    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_REVENUE_FAILURE, error });
  }
}

export function* getMembershipActivityTotals(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/corporate/memberships/activity/total_values", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString(),
      start_date: startDate.toString(),
      end_date: endDate.toString()
    });

    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_TOTALS_FAILURE, error });
  }
}

export function* getMembershipActivityValues(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/corporate/memberships/activity/members_values", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString(),
      start_date: startDate.toString(),
      end_date: endDate.toString()
    });

    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_VALUES_FAILURE, error });
  }
}

export function* getSalesActivityRevenue(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/corporate/sales/activity/revenues", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString(),
      start_date: startDate.toString(),
      end_date: endDate.toString()
    });

    yield put({ type: FETCH_SALES_ACTIVITY_REVENUE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_SALES_ACTIVITY_REVENUE_FAILURE, error });
  }
}

export function* getIntrosBooked(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/corporate/retention/activity/funnel_chart_values", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString(),
      start_date: startDate.toString(),
      end_date: endDate.toString()
    });

    yield put({ type: FETCH_INTROS_BOOKED_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_INTROS_BOOKED_FAILURE, error });
  }
}

export function* getSalesActivityBarChartValues(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/corporate/retention/activity/chart_values", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString(),
      start_date: startDate.toString(),
      end_date: endDate.toString()
    });

    yield put({ type: FETCH_BAR_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_BAR_CHART_FAILURE, error });
  }
}
